import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { UsersComponent } from './users/users.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserCreationComponent } from './user-creation/user-creation.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { OrgCreationComponent } from './organization/org-creation/org-creation.component';
import { OrgEditComponent } from './organization/org-edit/org-edit.component';
import { OrganizationComponent } from './organization/organization.component';
import { ServiceComponent } from './service/service.component';
import { ServiceCreationComponent } from './service/service-creation/service-creation.component';
import { ServiceEditComponent } from './service/service-edit/service-edit.component';
import { AgentComponent } from './service - Copy/agent.component';
import { AgentCreationComponent } from './service - Copy/agent-creation/agent-creation.component';
import { AgentEditComponent } from './service - Copy/agent-edit/agent-edit.component';
import { ServiceProviderEditComponent } from './service-provider/serviceProvider-edit/serviceProvider-edit.component';
import { ServiceProviderCreationComponent } from './service-provider/serviceProvider-creation/serviceProvider-creation.component';
import { ServiceProviderComponent } from './service-provider/serviceProvider.component';
import { DeliverServiceCreationComponent } from './service-provider/serviceProvider-edit/deliverService-creation/deliverService-creation.component';
import { DeliverServiceEditComponent } from './service-provider/serviceProvider-edit/deliverService-edit/deliverService-edit.component';
import { DocumentCreationComponent } from './documents/document-creation/document-creation.component';
import { DocumentComponent } from './documents/document.component';
import { DocumentTypeCreationComponent } from './document-type/documentType-creation/documentType-creation.component';
import { DocumentTypeEditComponent } from './document-type/documentType-edit/documentType-edit.component';
import { DocumentTypeComponent } from './document-type/documentType.component';
import { AgentServiceEditComponent } from './service - Copy/agent-edit/agentService-edit/agentService-edit.component';
import { AgentServiceCreationComponent } from './service - Copy/agent-edit/agentService-creation/agentService-creation.component';
import { DocumentEditComponent } from './documents/documents-edit/documents-edit.component';
import { UploadComponent } from './documents/upload-component/upload.component';
import { BreadcrumbComponent } from 'src/app/components/breadcrumb/breadcrumb.component';
import { FeatherIconComponent } from 'src/app/components/feather-icon/feather-icon.component';
import { BankSelectorComponent } from '../../shared/bank-selector/bank-selector.component';
import { DocumentServiceCreationComponent } from './service/service-edit/documentService-creation/documentService-creation.component';
import { DocumentServiceEditComponent } from './service/service-edit/documentService-edit/documentService-edit.component';
import { ToastrModule } from 'ngx-toastr';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { UserProfessionComponent } from './userProfession/userProfession.component';
import { UserProfessionCreationComponent } from './userProfession/userProfession-creation/userProfession-creation.component';
import { UserProfessionEditComponent } from './userProfession/userProfession-edit/userProfession-edit.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { UsersFilterFormComponent } from './users/users-filter-form/users-filter-form.component';
import { ShippingMethodComponent } from './shipping-method/shipping-method.component';
import { ShippingMethodCreationComponent } from './shipping-method/shipping-method-creation/shipping-method-creation.component';
import { ShippingMethodEditComponent } from './shipping-method/shipping-method-edit/shipping-method-edit.component';

@NgModule({
  declarations: [
    UsersComponent,
    UserCreationComponent,
    UserEditComponent,
    OrganizationComponent,
    OrgCreationComponent,
    OrgEditComponent,
    ServiceComponent,
    ServiceCreationComponent,
    ServiceEditComponent,
    AgentComponent,
    AgentEditComponent,
    AgentCreationComponent,
    ServiceProviderEditComponent,
    ServiceProviderCreationComponent,
    ServiceProviderComponent,
    DeliverServiceCreationComponent,
    DeliverServiceEditComponent,
    DocumentComponent,
    DocumentCreationComponent,
    DocumentTypeCreationComponent,
    DocumentTypeEditComponent,
    DocumentTypeComponent,
    AgentServiceEditComponent,
    AgentServiceCreationComponent,
    DocumentEditComponent,
    BreadcrumbComponent,
    FeatherIconComponent,
    UploadComponent,
    BankSelectorComponent,
    DocumentServiceCreationComponent,
    DocumentServiceEditComponent,
    UserProfessionComponent,
    UserProfessionCreationComponent,
    UserProfessionEditComponent,
    UsersFilterFormComponent,
    ShippingMethodComponent,
    ShippingMethodCreationComponent,
    ShippingMethodEditComponent
  ],
  imports: [
    AdminRoutingModule,
    SharedModule,
    NgbNavModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot()
  ],

  exports: [UploadComponent, BreadcrumbComponent, FeatherIconComponent, BankSelectorComponent],
})
export class AdminModule {
  static forRoot(): ModuleWithProviders<AdminModule> {
    return {
      ngModule: AdminModule,
      providers: [

      ],
    };
  }
}
